<template>
  <v-content class="spinelab-website-front">
  </v-content>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SiteSelection',
  data() {
    return {};
  },
  methods: {
    ...mapActions(['logout', 'setSite', 'showAlert']),
  },
  async created() {
    const result = await this.setSite();
    if (result === undefined) {
      await this.logout();
      this.showAlert({ message: undefined, type: 'error' });
      this.$router.push({ name: 'Login' });
    } else if (result === false) {
      this.$router.push({ name: 'TemplateSelection' });
    } else {
      this.$router.push({ name: 'BasicInformation' });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SiteSelection.vue